module.exports = __webpack_public_path__ + "img/desserts.5f172e9.jpg";